
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Calendar, Settings } from "lucide-react";

interface DashboardHeaderProps {
  title: string;
  description: string;
}

const DashboardHeader = ({ title, description }: DashboardHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <h1 className="text-3xl font-bold">{title}</h1>
        <p className="text-muted-foreground">{description}</p>
      </div>
      <div className="flex gap-2">
        <Button asChild variant="outline">
          <Link to="/settings">
            <Settings className="mr-2 h-4 w-4" />
            Configurações
          </Link>
        </Button>
        <Button asChild>
          <Link to="/schedule">
            <Calendar className="mr-2 h-4 w-4" />
            Agendar Consulta
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default DashboardHeader;
